import { postStatuses } from '@/util/postStatuses'
import { ctaTypes } from '@/util/ctaTypes'

export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    publishDateMenu: false,
    formattedPublishDate: null,
    image: null,
    categoryList: [],
    loadingCategories: false,
    categorySearchQuery: null,
    postStatuses,
    ctaTypes,
    post: {
      image: null,
      imageAlt: null,
      imageTitle: null,
      imageFilename: null,
      description: '',
      id: null,
      slug: '',
      title: '',
      titleTag: '',
      seoStructuredData: '',
      preview: '',
      content: '',
      publishDate: null,
      category: null,
      tags: [],
      featured: false,
      cta: null,
    },
  }
}
